<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>教授列表</span>
          </div>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">院校名称</label>
              <el-input
                v-model="searchData.sh_name"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">研究科</label>
              <el-input
                v-model="searchData.gs_name"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">教授名称</label>
              <el-input
                v-model="searchData.prof_name"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">邮箱</label>
              <el-input
                v-model="searchData.prof_email"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">教授标签</label>
              <el-input
                v-model="searchData.prof_tags"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">研究方向</label>
              <el-input
                v-model="searchData.prof_major"
                class="jm-input280"/>
            </div>
            <div class="box-content">
              <label class="form-tit">备注</label>
              <el-input
                v-model="searchData.prof_remark"
                class="jm-input280"/>
            </div>
            <!-- <div class="box-content">
                <label class="form-tit">关键字</label>
                <el-input
                  v-model="searchData.keyword"
                  class="jm-input280"/>
              </div> -->
          </div>
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="() => this.$store.commit('updateRefresh', true)">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            url="/index/offer/professor"
            :search-data="searchData"
          >
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <el-button v-if="$hasPermission(73)" size="mini" type="primary" @click="openDialog(scope.row)">修改信息
                </el-button>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
        <el-dialog class="dialog" :title="`编辑-${formData.prof_name}`" :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="width: 90%; margin-top: 30px">
            <el-form-item label="邮箱" label-width="120px">
              <el-input v-model="formData.prof_email" clearable class="jm-input280"/>
            </el-form-item>
            <el-form-item label="邮箱来源" label-width="120px">
              <el-select v-model="formData.prof_email_from" clearable class="jm-input280">
                <el-option value="个人主页" label="个人主页" />
                <el-option value="官网主页" label="官网主页" />
              </el-select>
            </el-form-item>
            <el-form-item label="教授标签" label-width="120px">
              <el-input v-model="formData.prof_tags" clearable class="jm-input280"/>
            </el-form-item>
            <el-form-item label="备注" label-width="120px">
              <el-input v-model="formData.prof_remark" clearable type="textarea" autocomplete="off" rows="5"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="saveFormData">保存</el-button>
            <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';

export default {
  data() {
    return {
      searchData: {},
      btnLoading: false,
      formData: {},
      dialogFormVisible: false,
    };
  },
  computed: {
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.searchData = {};
      this.$store.commit('updateRefresh', true);
    },
    // 打开编辑框
    openDialog(row) {
      this.formData = Object.assign({}, row);
      this.dialogFormVisible = true;
    },
    // 编辑保存
    saveFormData() {
      this.$http._post({
        url: '/index/offer/saveProfessor',
        data: this.formData
      }).then(() => {
        this.$message({ type: 'success', message: '备注编辑成功' });
        this.$store.commit('updateRefresh', true);
        this.dialogFormVisible = false;
      });
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
  }
};
</script>
<style scoped>
</style>
